













import { Component, Prop, Vue } from 'vue-property-decorator';
import BreadCrumbs from '@/components/parts/BreadCrumbs.vue';
import { Wrapper as MarkupWrapper } from '@/components/markup';

@Component({
  components: {
    BreadCrumbs,
    MarkupWrapper,
  },

  inheritAttrs: false,
})
export default class ComponentsLayoutBreadcrumbs extends Vue {
  // props
  @Prop({ type: Boolean, default: false })
  wide: false;

  @Prop({ type: String, default: 'white' })
  bg: string;

  @Prop({ type: Array, default: () => [] })
  breadcrumbs: Array<any>;

  @Prop({ type: Array, default: () => [] })
  prefix: Array<any>;

  // computed:
  get list() {
    const { prefix, breadcrumbs } = this;
    if (!prefix || !prefix.length) {
      return breadcrumbs;
    }
    return [...prefix, ...breadcrumbs];
  }

  get breadcrumbsKey() {
    return this.list.reduce((res, item) => {
      return res + item.text;
    }, '');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/Breadcrumbs.vue